$(document).ready(function () {
  var selectedProducts = [];
  var currentStep = 1;
  var initCollections = [];

  $('.tab-items .collection').each(function () {
  initCollections.push($(this).find('.product-grid').html());
  });

  $('.selected-products .mobile-toggle').click(function () {
    $('.selected-products').toggleClass('mobile-open');
  });

  $('.selected-products .bundle-info > h3').click(function () {
    $('.selected-products').toggleClass('mobile-open');
  });

  $('.product-card-bundle h3').unbind();

  addCardClickHandles();
  function addCardClickHandles() {
    $('.product-card-bundle a.add-to-bundle').unbind();
    $('.product-card-bundle a.add-to-bundle').click(function (e) {
      e.preventDefault();
      var productCard = $(this).closest('.product-card-bundle');
      if (!productCard.hasClass('selected')) {
        if ($(this).siblings('.select-variant-wrap').length) {
          productCard.siblings().find('.select-variant-wrap').hide(0);
          $(this).siblings('.select-variant-wrap').toggle(0);
        } else {
          if (!productCard.hasClass('selected')) {
            addProduct(productCard);
          }
        }
      }
    });

    $('.product-card-bundle #select-variant').unbind();
    $('.product-card-bundle #select-variant').click(function (e) {
      e.preventDefault();
      var productCard = $(this).closest('.product-card-bundle');
      if (productCard.find('select:last-child option:selected').attr('value')) {
        addProduct(productCard);
        $('.product-card-bundle .select-variant-wrap').hide(0);
      }
    });

    $('.product-card-bundle select').on('change', function () {
      var productCard = $(this).closest('.product-card-bundle');
      var option = productCard.find('.select-variant-wrap select:last-child option:selected');
      productCard.find('.price#price').text(option.data('price'));
      if(parseFloat(option.data('compare_at_price-val'))>parseFloat(option.data('price-val'))){
        productCard.find('.price#compare').text(option.data('compare_at_price'));
      }
      productCard.attr('data-id', option.data('id'));
      productCard.find('.product-price').attr('data-price', option.data('price-val'));
    });
  }

  function addProduct(productCard) {
    var limited = productCard.closest('.collection.limited').length;
    if (limited) {
      var selectedIndex = selectedProducts.find(x => x.step === currentStep);
      if (selectedIndex) {
        selectedProducts.splice(selectedIndex, 1);
      }
      productCard.closest('.collection.limited').find('.product-card-bundle').removeClass('selected').find('.add-to-bundle').text('Select');
    }

    var id = productCard.attr('data-id');
    var quantity = 1;
    if (productCard.find('.quantity-input').length) {
      quantity = +productCard.find('.quantity-input').val();
    }

    var variant = '';
    if (productCard.find('.select-variant-wrap').length) {
      productCard.find('.select-variant-wrap select').each(function () {
        variant += `<strong>${$(this).attr('name')}: </strong>${$(this).find('option:selected').attr('value')}<br>`;
      });
    }

    selectedProducts.push(
      {
        id,
        image: productCard.find('> .image img').attr('src'),
        title: productCard.find('.product-card-info h3').text().trim(),
        priceHtml: productCard.find('.product-card-info .price').html(),
        priceVal: +productCard.find('.product-card-info .product-price').attr('data-price'),
        step: currentStep,
        category: productCard.data('category'),
        quantity,
        variant
      }
    );

    var productCard = $(`.product-card-bundle[data-id="${id}"]`);
    productCard.addClass('selected');
    productCard.find('.add-to-bundle').text('Selected');
    drawBundle(selectedProducts);
  }

  function removeProduct(productId) {
    selectedProducts = selectedProducts.filter(obj => {
      return obj.id !== productId
    });
    $(`.product-card-bundle[data-id="${productId}"]`).removeClass('selected');
    var productCard = $(`.product-card-bundle[data-id="${productId}"]`);
    productCard.find('.add-to-bundle').text('Select');
    drawBundle(selectedProducts);
  }

  function drawBundle(products) {
    $(`.list-step`).removeClass('done');
    $(`.tabs-nav li`).removeClass('done');

    if (products.length > 0) {
      $(`.list-step .products`).html('');
      var total = 0; 
      for (var product of products) {
        var html = '';
        var image = '';
        if (product.image) {
          image += `<img src="${product.image}">`;
        }
        var quantity = '';
        if (product.quantity > 1) {
          quantity += `<div class="variant quantity"><strong>Quantity: </strong>${product.quantity}</div>`;
        }
        html += `
          <div class="bundle-item" data-id="${product.id}" data-quantity="${product.quantity}">
            <div class="image">
              ${image}
            </div>
            <div class="bundle-item-info">
              <h3>${product.title}</h3>
              <div class="variant">${product.variant}</div>
              ${quantity}

              <div class="price">${product.priceHtml}</div>
            </div>
            <div class="remove"><i class="icofont-close-circled"></i></div>
          </div>
        `;
        $(`.list-step[data-step-num=${product.step}] .products`).append(html);
        $(`.list-step[data-step-num=${product.step}]`).addClass('done');
        $(`.tabs-nav li[data-step-num=${product.step}]`).addClass('done');

        total += product.priceVal * product.quantity;
      }

      var nextStepInfo = $('.build-bundle li.active').next();
      if (nextStepInfo.length) {
        $('#continue-btn').html('Continue to ' + nextStepInfo.data('title') + ' <i class="icofont-simple-right mobile"></i>');
      }
      $('#continue-btn').attr('disabled', false);

      $('.selected-products').addClass('has-products');
      $('.action-buttons .total .val').html((total / 100).toLocaleString('en-US', {maximumFractionDigits: 2}));
      $('.build-bundle .tabs .tabs-nav').removeClass('disabled');

      $('.bundle-item .remove').click(function (e) {
        e.preventDefault();
        removeProduct($(this).closest('.bundle-item').attr('data-id'));
      });
    } else {
      $('.selected-products').removeClass('has-products');
      $('#continue-btn').attr('disabled', true);
      $('.action-buttons .total .val').html(0);
      $('.build-bundle .tabs .tabs-nav').addClass('disabled');
      goToStep(1);
    }
    drawMobileCurrentItems(products);
  }

  function drawMobileCurrentItems(products) {
    $(`.selected-products .current-products`).html('');
    var html = '';
    var hasProducts = false;
    for (var product of products) {
      if (product.step == currentStep) {
        hasProducts = true;
        var image = '';
        if (product.image) {
          image += `<img src="${product.image}">`;
        }
        html += `
          <div class="bundle-item" data-id="${product.id}" data-category="">
            <div class="image">
              ${image}
            </div>
            <div class="bundle-item-info">
              <h3>${product.title}</h3>
            </div>
          </div>
        `;
      }
    }
    $(`.selected-products .current-products`).append(html);

    var step = $('.build-bundle .tabs-nav li').eq(currentStep -1);
    if (!hasProducts) {
      $('.selected-products .mobile-toggle .step-title').text(step.data('title-mobile'));
    } else {
      $('.selected-products .mobile-toggle .step-title').text('Your ' + step.data('title-mobile-dropdown') + ':');
    }
  }

  $('#continue-btn').click(function (e) {
    e.preventDefault();
    if (!$(this).is(':disabled')) {
      goToStep(currentStep + 1);
    }
  });

  $('a[href="#add-to-cart"]').click(function (e) {
    e.preventDefault();
    addBundleToCart();
    goToStep(1);
    for (product of selectedProducts) {
      removeProduct(product.id);
    }
  });

  function goToStep(stepNum) {
    var step = $('.build-bundle .tabs-nav li').eq(stepNum - 1);
    var nextStepInfo = step.next();
    if (step.length) {
      currentStep = stepNum;

      var tabs = $('.build-bundle .tabs');

      tabs.find('.tabs-nav li').removeClass('active');
      step.addClass('active');
      tabs.find('.tab-items > .item').removeClass('active');
      tabs.find('.tab-items > .item').eq(step.index()).addClass('active');

      var collection = $('.build-bundle .tab-items > .item').eq(stepNum - 1).find('.collection');
      var checkCompatibility = collection.hasClass('check-compatibility');
      if (checkCompatibility) {
        collection.find('.product-grid').html(initCollections[stepNum - 1]);
        addCardClickHandles();
        if ($('.build-bundle .tabs-nav li').eq(stepNum - 2) && $('.build-bundle .tabs-nav li').eq(stepNum - 2).hasClass('done')) {
          collection.find('.product-card-bundle').each(function () {
            var cat = $(this).data('category');
            var index = selectedProducts.findIndex(item => item.category === cat);
            if (index < 0) {
              $(this).remove()
            }
          });
          console.log(collection);
          if(collection[0].children[2].children[0].childElementCount == 0){
            collection[0].children[2].children[0].innerHTML = 'This product does not need Cushion to select. Please continue with other Bundles.';
          }
        }
      }

      if (nextStepInfo.length) {
        $('#continue-btn').html('Continue to ' + nextStepInfo.data('title') + ' <i class="icofont-simple-right mobile"></i>');
      } else {
        $('#continue-btn').html('Add to Cart');
      }
      drawMobileCurrentItems(selectedProducts);
    } else {
      addBundleToCart();
      goToStep(1);
      for (product of selectedProducts) {
        removeProduct(product.id);
      }
    }
  }

  function addBundleToCart() {
    var items = [];
    for (product of selectedProducts) {
      items.push({
        id: product.id,
        quantity: product.quantity
      });
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {items},
      dataType: 'json',
      success: function(data) {
        updateCart(true);
        window.scrollTo(0, 0);
      }
    });
  }

  $('.build-bundle .tabs .tabs-nav h3').unbind();
  $('.build-bundle .tabs .tabs-nav h3').click(function () {
    if (!$(this).closest('.tabs-nav').hasClass('disabled')) {
      var index = $(this).closest('li').index();
      goToStep(index + 1);
    }
  });

  $('.category-filter input, .brand-filter input').on('change', function () {
    var collection = $(this).closest('.collection');
    var index = $(this).closest('.item').index();
    filterCollection(collection, index);
  });

  $('.price-filter input[type="submit"]').on('click', function (e) {
    e.preventDefault();
    var collection = $(this).closest('.collection');
    var index = $(this).closest('.item').index();
    filterCollection(collection, index);
  });

  function filterCollection(collection, collectionIndex) {
    var selectedTags = [], selectedBrands = [];
    var priceFilterActive = false;
    collection.find('.active-filters .active-filter').remove();
    collection.find('.filter-group').removeClass('active');
    collection.find('.filter-wrap').hide(0);
    collection.find('.category-filter input').each(function () {
      if ($(this).is(':checked')) {
        selectedTags.push($(this).val());
        collection.find('.active-filters').append(`<a class="active-filter active-filters__remove-filter category" data-tag="${$(this).val()}" href="#"><i class="icofont-close-circled"></i> ${$(this).val()}</a>`);
      }
    });

    collection.find('.brand-filter input').each(function () {
      if ($(this).is(':checked')) {
        selectedBrands.push($(this).val());
        collection.find('.active-filters').append(`<a class="active-filter active-filters__remove-filter brand" data-tag="${$(this).val()}" href="#"><i class="icofont-close-circled"></i> ${$(this).val()}</a>`);
      }
    });

    var priceMinInput = collection.find('.price-filter input#Filter-price-min');
    var priceMaxInput = collection.find('.price-filter input#Filter-price-max');
    if (priceMinInput.val() !== '' && priceMaxInput.val() !== '' && (priceMinInput.val() != +priceMinInput.data('init-val') ||  priceMaxInput.val() != +priceMaxInput.data('init-val'))) {
      priceFilterActive = true;
    }

    if (selectedTags.length || selectedBrands.length || priceFilterActive) {
      var filteredItemsHTML = '';
      var defaultItems = initCollections[collectionIndex];
      $(defaultItems).find('.product-card-bundle').each(function () {
        if (selectedTags.length) {
          var matchesTags = false;
          var tags = $(this).data('tags');
          for (tag of selectedTags) {
            if (tags.includes(tag)) {
              matchesTags = true;
              break;
            }
          }
          if (!matchesTags) return;
        }

        if (selectedBrands.length) {
          var vendor = $(this).data('vendor');
          if (!selectedBrands.includes(vendor)) return;
        }

        if (priceFilterActive) {
          var minPrice = +priceMinInput.val();
          var maxPrice = +priceMaxInput.val().replace('.', ',');
          var productPrice = +$(this).find('.product-price').attr('data-price') / 100;
          if (productPrice < minPrice || productPrice > maxPrice) {
            return;
          }
        }

        filteredItemsHTML += $(this).get(0).outerHTML;
      });

      collection.find('.product-grid .wrapper').html(filteredItemsHTML);
      collection.find('.active-filters').show(0);
    } else {
      collection.find('.product-grid').html(initCollections[collectionIndex]);
      collection.find('.active-filters').hide(0);
    }

    if (selectedTags.length) {
      collection.find('.category-filter .filter-name span').text(' (' + selectedTags.length + ')');
    } else {
      collection.find('.category-filter .filter-name span').text('');
    }

    if (selectedBrands.length) {
      collection.find('.brand-filter .filter-name span').text(' (' + selectedBrands.length + ')');
    } else {
      collection.find('.brand-filter .filter-name span').text('');
    }
    collection.find('.filters-title .filter-num').text('(' + (selectedTags.length + selectedBrands.length) + ')');

    addCardClickHandles();

    $('.active-filters__remove-filter').click(function (e) {
      e.preventDefault();
      var tag = $(this).attr('data-tag');
      var collection = $(this).closest('.collection');
      var index = $(this).closest('.item').index();
      collection.find(`input[type="checkbox"][value="${tag}"]`).prop('checked', false);
      filterCollection(collection, index);
      $(this).remove();
    });
  }

  $('a[href="#remove-all-filters"]').click(function (e) {
    e.preventDefault();
    $('.filter-item input[type="checkbox"]').prop('checked', false);
    var collection = $(this).closest('.collection');
    var index = $(this).closest('.item').index();
    var priceMinInput = collection.find('.price-filter input#Filter-price-min');
    var priceMaxInput = collection.find('.price-filter input#Filter-price-max');
    priceMinInput.val(0);
    priceMaxInput.val(priceMaxInput.data('init-val'));
    filterCollection(collection, index);
  });

  $('.product-card-bundle .image, .product-card-bundle h3 a').click(function (e) {
    e.preventDefault();
    var popup = $(this).closest('.product-card-bundle').find('.popup');
    popup.fadeIn(200);
    popup.find('.pdp-main .slider-for').slick('unslick');
    popup.find('.pdp-main .slider-nav').slick('unslick');
    popup.find('.pdp-main .slider-for').slick({
      centerMode: true,
      variableWidth: true,
      arrows: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            fade: true,
            centerMode: false,
            variableWidth: false
          }
        }
      ]
    });

    popup.find('.pdp-main .slider-nav').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1
    });
  });

  $('a[href="#generate-bundle"]').click(function (e) {
    e.preventDefault();
    $('#generate-bundle-data .bundle-item').each(function () {
      var id = $(this).data('id');
      var productCard = $(`.product-card-bundle[data-id="${id}"]`);
      if (productCard.length) {
        goToStep($(this).data('step'));
        if (productCard.find('select').length) {
          var option = productCard.find('select option:nth-child(2)');
          productCard.find('select').val(option.val());
        }
        if (productCard.find('.quantity-input').length) {
          productCard.find('.quantity-input').val($(this).data('quantity'));
        }
        addProduct(productCard);
      }
    });
    goToStep($('.bundle-collections .tabs-nav li').length);
  });
});